import React, { useEffect, useState } from 'react'
import { dict, translate as loc } from 'Localisation'
import { checkPermList } from 'helpers'
import { permissions } from 'settings/permissions'
import ActionMenu from 'components/UI/ActionMenu/ActionMenu'
import asideModalStore from 'Stores/asideModalStore'
import ContractPlans from 'components/ContentBox/Global/GlobalModalSingle/templates/WorkPlain/ContractPlans'
import usersStore from 'Stores/usersStore'
import st from './EmployeeContract.module.scss'
import { dateFormat } from 'helpers/date'
import VacationInfo from './VacationInfo'
import { superAxiosRequest } from 'axiosApi'
import swal from 'sweetalert'
import { ReactComponent as DownIcon } from 'components/UI/icons/arrow-down-s-line.svg'
import modalStore from 'Stores/modalStore'
import ContractDoc from './ContractDoc'
import { localisationMaster } from 'Localisation/Localisation'

const EmployeeContract = ({ contract, user, translate }) => {
  const [open, setOpen] = useState(false)
  const [docs, setDocs] = useState([])
  const getContractStatusClass = () => {
    const now = Date.now()
    const dateFrom = new Date(contract.date_from).getTime()
    const dateUntil = new Date(contract.date_until).getTime()
    if (dateUntil < now) {
      return 'last'
    } else if (dateFrom <= now && now <= dateUntil) {
      return 'current'
    } else if (dateFrom > now) {
      return 'future'
    }
  }

  const addDocToList = (newDoc) => {
    setDocs((prevDocs) => [...prevDocs, newDoc])
  }

  const removeDocFromList = (docId) => {
    setDocs((prevDocs) => prevDocs.filter((doc) => doc.id !== docId))
  }

  useEffect(() => {
    const filteredDocs = usersStore.userDocslist.filter(
      (x) => x.contract === contract.id,
    )
    setDocs(filteredDocs)
  }, [contract])

  function convertMinutesToHoursDecimal(minutes) {
    const hours = Math.floor(minutes / 60)
    const decimalPart = (minutes % 60) / 60
    return hours + decimalPart
  }
  const menu = [
    ...(checkPermList(permissions.add_contract_docs)
      ? [{ name: 'Upload file', action: 'upload_file' }]
      : []),
    ...(checkPermList(permissions.add_contracts)
      ? [
          { name: translate.edit, action: 'edit' },
          { name: translate.to_extend_the_contract, action: 'prolong' },
          { name: translate.change_the_clock, action: 'plans' },
        ]
      : []),
    ...(checkPermList(permissions.delete_contracts)
      ? [{ name: translate.delete_contract, action: 'delete' }]
      : []),
  ]

  const { userContracts } = usersStore

  const action = (data, e, item) => {
    let ms
    switch (data) {
      case 'upload_file':
        let modal_settings = {
          name: 'course-lesson',
          link: 'employees/appendix',
          button: localisationMaster('button-two', 'company/age', 'add_age'),
          title: translate?.add_documents,
          type: 'SelectorAndInput',
          active_inputs: ['text', 'textarea', 'media'],
          data: 'media',
          media: true,
          name_media: 'file',
          pl_text: translate?.document_name,
          name_text: 'title',
          pl_textarea_tags: translate?.comment,
          name_textarea_tags: 'description',
          media_type: translate?.any_file_except_exe_bat,
          func: (newDoc) => addDocToList(newDoc),
        }
        let inner = {
          contract: contract.id,
          employee_id: contract.employee_id,
        }
        modalStore.activity(modal_settings, inner)
        break
      case 'edit':
        ms = {
          name: 'employee_contract',
          link: 'employees/contract/' + item.id,
          button: loc(dict.main_page.text_30),
          title: loc(dict.contract.text_12),
          type: 'employee_contract',
          data: 'json',
          is_put: true,
          profile: user.profile.id,
          isResponsive: true,
          valid: {
            title: 'required',
          },
        }
        asideModalStore.activity(ms, item)
        break
      case 'prolong':
        ms = {
          name: 'employee_contract',
          link: 'employees/contract',
          button: loc(dict.main_page.text_30),
          title: loc(dict.contract.text_13),
          type: 'employee_contract',
          data: 'json',
          profile: user.profile.id,
          is_prolong: true,
          isResponsive: true,
          valid: {
            title: 'required',
          },
        }
        asideModalStore.activity(ms, {
          ...item,
          title: item.title + `'\\'${translate?.prolongation}`,
        })
        break
      case 'plans':
        ms = {
          title:
            translate?.training_and_test_plans_by_contract + ' ' + item.title,
          modalBodyComponent: () => <ContractPlans />,
          button: loc(dict.main_page.text_30),
          is_put: true,
          isResponsive: true,
          link: 'employees/contract_plans/' + item.id,
        }
        asideModalStore.activity(ms, {
          test_plan_mins: item.test_plan_mins,
          hour_type: item.hour_type,
          teaching_plan_mins: item.teaching_plan_mins,
          teaching_plan_hour_type: item.teaching_plan_hour_type,
        })
        break
      case 'delete':
        swal({
          title: translate?.contract_deletion,
          text: translate?.confirm_contract_deletion,
          icon: 'warning',
          buttons: [translate?.no, translate?.yes],
          dangerMode: true,
        }).then((yes) => {
          if (yes) {
            superAxiosRequest({
              link: 'employees/contract/' + item.id,
              method: 'delete',
            }).then(() => {
              usersStore.setUserContracts(user.profile.id)
            })
          }
        })
      default:
        break
    }
  }

  return (
    <div className={open ? st.employeeContractIsOpen : st.employeeContract}>
      <div className={`${st.header} ${st[getContractStatusClass()]}`}>
        <h4 className={open ? st.involved : st.default}>{contract.title}</h4>
        <div className={st.events}>
          <div
            className={open ? st.detailInvolved : st.detail}
            onClick={() => setOpen(!open)}
          >
            <DownIcon style={{ transform: open ? 'rotate(180deg)' : 'none' }} />
          </div>
          <ActionMenu menu={menu} action={action} items={contract} />
        </div>
      </div>

      {open && (
        <div>
          <div className={st.body}>
            <div className={st.bodyMain}>
              <VacationInfo translate={translate} contract={contract} />
              <ul className={st.params}>
                <li className={st.param}>
                  <span>{loc(dict.contract.text_3)}:</span>
                  <time>{dateFormat(contract.date_from, 'dd MMMM YYYY')}</time>
                </li>

                <li className={st.param}>
                  <span>{loc(dict.contract.text_4)}:</span>
                  <time>{dateFormat(contract.date_until, 'dd MMMM YYYY')}</time>
                </li>

                {contract.vacation_mins && (
                  <li className={st.param}>
                    <span>{loc(dict.work_table_listing.working_day)}:</span>
                    <span>
                      <b>
                        {convertMinutesToHoursDecimal(contract.vacation_mins)}
                      </b>{' '}
                      {loc(dict.contract.text_8)}
                    </span>
                  </li>
                )}

                {contract.vacation_days && (
                  <li className={st.param}>
                    <span>{loc(dict.work_table_listing.vacation_days)}:</span>
                    <span>
                      <b>{+contract.vacation_days}</b> {loc(dict.contract.d)}
                    </span>
                  </li>
                )}

                {contract.vacation_corrections !== null &&
                  contract.vacation_corrections !== undefined && (
                    <li className={st.param}>
                      <span>{translate.corrections}:</span>
                      <span>
                        <b>{contract.vacation_corrections}</b>{' '}
                        {loc(dict.contract.d)}
                      </span>
                    </li>
                  )}

                {!!contract.test_plan_mins && (
                  <li className={st.param}>
                    <span>{translate?.online_registration}:</span>
                    <span>
                      <b>{`${contract.test_plan_mins / 60}`}</b>
                      {` ${contract?.hour_type === 45 ? translate?.ac_h : translate?.astr_h} ${translate?.hours_per_month}`}
                    </span>
                  </li>
                )}

                {!!contract.teaching_plan_mins && (
                  <li className={st.param}>
                    <span>{translate?.training_plan}:</span>
                    <span>
                      <b>{`${contract.teaching_plan_mins / contract.teaching_plan_hour_type}`}</b>
                      {` ${contract.teaching_plan_hour_type === 45 ? translate?.ac_h : translate?.astr_h} ${translate?.hours_per_month}`}
                    </span>
                  </li>
                )}
              </ul>
            </div>
            {contract.comment && (
              <div className={st.comment}>{contract.comment}</div>
            )}
          </div>
          <div className={st.contractDocs}>
            {docs.map((doc) => (
              <ContractDoc
                key={doc.id}
                doc={doc}
                onDelete={removeDocFromList}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

export default EmployeeContract
